<template>
  <router-link
    :to="{ name: 'channels.show', params: { category: category.slug, channel: channel.slug }}"
    class="relative w-full min-h-24 flex bg-grey-1 cursor-pointed hover:bg-blue-2 md:rounded-lg mb-4 shadow-md transition-bg transition-250 | channel-item"
  >
    <div class="w-1/4 relative flex items-center justify-center">
      <img
        v-if="channel.image"
        :src="channel.image.thumb"
        class="w-full h-full object-cover absolute z-0 md:rounded-l-lg"
      />
      <img
        v-else
        src="@/assets/channel_background-300w.png"
        class="w-full h-full object-cover absolute z-0 md:rounded-l-lg"
      />
      <div
        class="w-full h-full absolute z-10 bg-grey-1 opacity-50 md:rounded-l-lg transition-bg transition-250 | channel-background-overlay"
      ></div>
    </div>
    <div class="w-3/4 px-4 py-2 flex items-center">
      <div class="flex-1">
        <div
          class="flex items-center text-xl md:text-2xl font-semibold text-blue-7 transition-color transition-250 | channel-item-name"
        >
          <lock-icon class="mr-2 | channel-item-icon" v-if="channel.locked"></lock-icon>
          {{ channel.name }}
        </div>
        <rich-content-item class="text-base md:text-lg text-grey-7" :html="channel.description"></rich-content-item>
        <div class="text-sm mt-1 opacity-75 uppercase text-grey-7 lg:hidden">
          <span class="hidden sm:inline-block font-semibold">Threads</span>
          <span class="hidden sm:inline-block text-blue-7 font-bold ml-1">{{ channel.thread_count }}</span>
          <span class="hidden sm:inline-block font-semibold ml-2">Replies</span>
          <span class="hidden sm:inline-block text-blue-6 font-bold ml-1">{{ channel.reply_count }}</span>
          <span class="font-semibold ml-0 sm:ml-2" v-if="channel.latest_post">Last Post</span>
          <span
            class="text-yellow-7 font-bold ml-1"
            v-if="channel.latest_post"
          >{{ fromNow(channel.latest_post) }}</span>
        </div>
      </div>
      <div
        class="hidden lg:flex flex-col justify-center text-sm opacity-75 uppercase text-grey-7 ml-2"
      >
        <div class="text-right">
          <span class="font-semibold">Threads</span>
          <span class="text-blue-7 font-bold ml-1">{{ channel.thread_count }}</span>
        </div>
        <div class="text-right">
          <span class="font-semibold">Replies</span>
          <span class="text-blue-6 font-bold ml-1">{{ channel.reply_count }}</span>
        </div>
        <div class="text-right">
          <span class="font-semibold" v-if="channel.latest_post">Last Post</span>
          <span
            class="text-yellow-7 font-bold ml-1"
            v-if="channel.latest_post"
          >{{ fromNow(channel.latest_post) }}</span>
        </div>
      </div>
    </div>
    <div class="new-badge" v-if="channel.new">
      <alert-circle-icon></alert-circle-icon>
    </div>
  </router-link>
</template>

<script>
import DateTime from "@/mixins/DateTime"
import { LockIcon, AlertCircleIcon } from "vue-feather-icons"
import RichContentItem from "@/components/Items/RichContentItem"

export default {
  name: "ChannelItem",
  components: {
    LockIcon,
    AlertCircleIcon,
    RichContentItem
  },
  mixins: [DateTime],
  props: {
    category: {
      required: true
    },
    channel: {
      required: true
    }
  },
  computed: {
    lastPost() {
      if(!this.channel.latest_reply && !this.channel.latest_thread) return null
      if(!this.channel.latest_reply && this.channel.latest_thread) return this.channel.latest_thread.created_at
      return this.latest(this.channel.latest_reply.created_at, this.channel.latest_thread.created_at)
    }
  }
}
</script>

<style lang="scss">
.channel-item:hover .channel-item-name {
  @apply text-yellow-7;
}

.channel-item:hover .channel-item-icon {
  @apply text-yellow-7 #{!important};
}

.channel-item:hover .channel-background-overlay {
  @apply bg-blue-2;
}
</style>
